import { fetchAdminStatus } from "@features/admin/api/adminStatus";
import { fetchMemberProfile } from "@features/admin/api/memberProfile";
import { fetchMemberSubscriptions } from "@features/admin/api/memberSubscriptions";
import { fetchMembers } from "@features/admin/api/members";
import type { MemberListParams } from "@features/admin/model/types";
import { keepPreviousData, queryOptions } from "@tanstack/react-query";

/**
 * admin 도메인 쿼리 팩토리.
 */
export const adminQueries = {
  all: () => ["admin"] as const,
  statusKey: () => [...adminQueries.all(), "status"] as const,
  membersKey: (params: MemberListParams) => [...adminQueries.all(), "members", params] as const,
  memberProfileKey: (userId: number) => [...adminQueries.all(), "memberProfile", userId] as const,
  memberSubscriptionsKey: (companyId: number) => [...adminQueries.all(), "memberSubscriptions", companyId] as const,

  status: () =>
    queryOptions({
      queryKey: adminQueries.statusKey(),
      queryFn: fetchAdminStatus,
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }),

  members: (params: MemberListParams) =>
    queryOptions({
      queryKey: adminQueries.membersKey(params),
      queryFn: () => fetchMembers(params),
      staleTime: 0,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      placeholderData: keepPreviousData,
    }),

  memberProfile: (userId: number) =>
    queryOptions({
      queryKey: adminQueries.memberProfileKey(userId),
      queryFn: () => fetchMemberProfile(userId),
      staleTime: 0,
      enabled: !!userId,
    }),

  memberSubscriptions: (companyId: number) =>
    queryOptions({
      queryKey: adminQueries.memberSubscriptionsKey(companyId),
      queryFn: () => fetchMemberSubscriptions(companyId),
      staleTime: 0,
      enabled: !!companyId,
    }),
};
